
import React from "react";
import { Cake, MapPin } from "lucide-react";
import { formatDateForDisplay } from "@/utils/dateUtils";

interface BirthInfoCardProps {
  birthDate: string;
  birthPlace: string;
  personLabel?: string;
}

export const BirthInfoCard: React.FC<BirthInfoCardProps> = ({ birthDate, birthPlace, personLabel }) => {
  if (!birthDate && !birthPlace) return null;

  return (
    <div className="bg-card rounded-xl shadow-sm border overflow-hidden transition-all duration-300 hover:shadow-md">
      <div className="border-b bg-muted/30 px-6 py-4 flex items-center">
        <Cake className="h-5 w-5 text-primary mr-2" />
        <h3 className="font-medium text-foreground">{personLabel ? `${personLabel}'s Birth` : 'Birth'}</h3>
      </div>
      <div className="p-6">
        <div className="space-y-2 text-muted-foreground">
          {birthDate && (
            <p className="text-foreground">{formatDateForDisplay(birthDate)}</p>
          )}
          {birthPlace && (
            <div className="flex items-center gap-2 text-sm">
              <MapPin className="h-4 w-4" />
              <span>{birthPlace}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
